import { createSelector } from '@reduxjs/toolkit';
import { getUserId, getUserIsLoading } from 'store/session/selectors';

export const userProfilePageSelector = createSelector(getUserId, getUserIsLoading, (userId, isLoading) => ({
    userId,
    isLoading,
}));
